// Floorplan viewer w/pan and zoom

import Panzoom from '@panzoom/panzoom'

function initPanzoom(floorplanElem) {
  let modal = floorplanElem.closest('.availability-modal')
  let parentElem = floorplanElem.parentElement;
  let zoomInButton = parentElem.querySelector('.floorplan-zoom-in');
  let zoomOutButton = parentElem.querySelector('.floorplan-zoom-out');

  const panzoom = Panzoom(floorplanElem, {
    contain: 'outside',
    minScale: 1,
    maxScale: 4,
    touchAction: 'pan-x pan-y',
    pinchAndPan: true
  })

  zoomInButton.addEventListener('click', panzoom.zoomIn)
  zoomOutButton.addEventListener('click', panzoom.zoomOut)

  modal.addEventListener('hidden.bs.modal', (event) => {
    panzoom.reset({ animate: false });
  })

  // Only use panZoom with two fingers on touch devices
  floorplanElem.addEventListener('touchstart', function (event) {
    if (event.touches.length > 1) {
      event.preventDefault(); // prevent browser scroll
      parentElem.classList.remove('has-single-touch');
      panzoom.setOptions({ disablePan: false });
    } else {
      parentElem.classList.add('has-single-touch');
      panzoom.setOptions({ disablePan: true });
    }
  });

  function handleTouchend(event) {
    if (event.touches.length <= 1) {
      parentElem.classList.remove('has-single-touch');
      panzoom.setOptions({ disablePan: false });
    }
  }

  floorplanElem.addEventListener('touchend', handleTouchend);
  floorplanElem.addEventListener('touchcancel', handleTouchend);

}

function initFloorplans() {
  const floorplanElems = document.querySelectorAll('.floorplan');

  floorplanElems.forEach(element => {
    initPanzoom(element);
  });
}

initFloorplans();

const availTabs = document.getElementById('availability-tabs');

if (availTabs) {
  availTabs.addEventListener('htmx:afterSwap', (event) => {
    initFloorplans();
  });
}

